module.exports = __webpack_public_path__ + "src/images/products/active/10_Reverse Weave Jogger Pants.png";